import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';
import { Panel } from 'react-bootstrap';
import Switch from 'react-bootstrap-switch';
import { Link } from 'react-router-dom'

import Modal from '../../common/components/Modal';

import EmbedStringGenerator from '../lib/EmbedStringGenerator';
import RestrictedComponent from '../../lib/components/form/RestrictedComponent';
import schema from '../../routes/permissions/schema';

var Preference = createReactClass({

    getInitialState: function () {
        return {
            renderMode: "script",
            deleteModal: false
        };
    },

    handleEmbedToggle: function () {
        this.setState({
            renderMode: (this.state.renderMode == 'script') ? 'iframe' : 'script'
        });
    },

    toggleDeleteModal: function (ev) {
        ev && ev.preventDefault();
        this.setState({
            deleteModal: !this.state.deleteModal
        });
    },

    handleDelete: function (ev) {
        ev && ev.preventDefault();
        this.props.actions.delete({
            preferenceID: this.props.preferenceID
        });
    },
    render: function () {
        var { renderHeader, renderFooter, renderDeleteModal } = this;
        return (
            <div className="preference">
                <Panel>
                    <Panel.Heading>
                        <Panel.Title>{renderHeader()}</Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                        <EmbedStringGenerator {...this.props}
                            domain="listing"
                            renderMode={this.state.renderMode}/>
                    </Panel.Body>
                    <Panel.Footer>{renderFooter()}</Panel.Footer>
                </Panel>

                {renderDeleteModal()}
            </div>
        );
    },

    renderHeader: function () {
        var toggleProps = {
            value: (this.state.renderMode == "script") ? true : false,
            bsSize: 'small',
            onText: 'Script Tag',
            offText: 'iFrame',
            animate: false,
            onChange: this.handleEmbedToggle
        };

        return (<div className="clearfix">
            <div className="col-md-6">
                <h4>{this.props.preference.name}</h4>
            </div>
            <div className="col-md-6 toggle">
                <Switch {...toggleProps} />
            </div>
        </div>);
    },

    renderFooter: function () {
        var { toggleDeleteModal } = this;
        return (<div className="preference-footer">
            <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_CHANNEL_SETTINGS.UPDATE}>
                <Link to={'/manage/listing/edit?id=' + this.props.preferenceID}>
                    <button className="btn btn-default" style={{marginRight: '1em'}}>
                        <i className="fa fa-pencil"/>Edit
                    </button>
                </Link>
            </RestrictedComponent>
            <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_CHANNEL_SETTINGS.DELETE}>
                <button className="btn btn-danger" onClick={toggleDeleteModal}>
                    <i className="fa fa-trash-can"/> Delete
                </button>
            </RestrictedComponent>
        </div>);
    },

    renderDeleteModal: function () {
        if (this.state.deleteModal) {
            return (<Modal
                saveAction={<button className="btn btn-danger" onClick={this.handleDelete}>
                    <i className="fa fa-trash-can"/> Delete
                </button>}
                cancelModal={this.toggleDeleteModal}>
                <Modal.Header>Delete Listing Preference</Modal.Header>
                <Modal.Body>
                    <div className="alert alert-danger">
                        <p><strong>Notice:</strong> This cannot be undone!</p>
                    </div>
                </Modal.Body>
                <Modal.Footer></Modal.Footer>
            </Modal>);
        }
    }
});

export default Preference;
